import React from "react"
import HTMLCheatSheet from "../components/cheatsheets/tags-cheatsheet"
import CSSCheatSheet from "../components/cheatsheets/css-cheatsheet"

export default [
  {
    _id: 0,
    title: "Class Overview",
    subtitle: "What this class is about and how to maximize your results.",
    time: "4:59",
    vid_link: "428258798",
    desc: "",
  },
  {
    _id: 1.1,
    title: "Module 1: Setup",
    desc: "",
  },
  {
    _id: 2,
    title: "What 'Coding' Really Means & the Trifecta",
    subtitle: "You must understand how the system was built before using it.",
    time: "7:50",
    desc: (
      <div>
        Aren&#x27;t you glad we don&#x27;t use punch cards anymore?
        <p>
          Just to get the hang of giving detailed instrutions, try writing out
          an instruction manual for making a PB&amp;J sandwich. Make it 2 pages
          long - single spaced ;)
        </p>
      </div>
    ),
    vid_link: "428258809",
  },
  {
    _id: 3,
    title: "The Best Code Editor on the Planet",
    subtitle: "And why writing code from scratch is dumb.",
    time: "7:01",
    desc: (
      <div>
        <p>
          You can download Visual Studio Code here:{" "}
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://code.visualstudio.com/"
          >
            https://code.visualstudio.com
          </a>
        </p>
        <p>
          You can download the extensions we discussed right inside VSCode once
          you&#x27;ve downloaded it.
        </p>
        <p>
          Check out{" "}
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://github.com/"
          >
            Github
          </a>{" "}
          and browse around to see what exists in the code world.
        </p>
      </div>
    ),
    vid_link: "428258823",
  },
  {
    _id: 4,
    title: "Adding Extensions in the Code Editor",
    subtitle:
      "There are a few must-have extensions that you need to ensure you have.",
    time: "2:16",
    desc: (
      <div>
        <p>
          Just click the &#x27;extensions&#x27; button on the side bar in VScode
          and search for &#x27;Prettier&#x27; and install it. Do the same with
          &#x27;Live Server&#x27;.
        </p>
      </div>
    ),
    vid_link: "428258837",
  },
  {
    _id: 4.1,
    title: "Module 2: Building Your First Site",
    desc: "",
  },
  {
    _id: 5,
    title: "The Structure of a Webpage",
    subtitle: "How to create your very first barebones website.",
    time: "6:40",
    desc: "Besure to checkout the HTML Cheatsheet in the next lecture. :)",
    vid_link: "428258858",
  },
  {
    _id: 50,
    title: "BONUS: HTML CHEATSHEET",
    subtitle: "Never get lost in the jargon of tags!",
    desc: <HTMLCheatSheet />,
  },
  {
    _id: 6,
    title: "Making Your Page Beautiful",
    subtitle: "Using CSS to give your page some life",
    time: "11:05",
    desc: "Be sure to find the CSS cheatsheet in the next lecure!",
    vid_link: "428258870",
  },
  {
    _id: 60,
    title: "BONUS: CSS CHEATSHEET",
    subtitle: "Making sure you've always got <style>",
    desc: <CSSCheatSheet />,
  },
  {
    _id: 7,
    title: "Organizing Your Site",
    subtitle: "Get organization right before building anything big.",
    time: "3:47",
    desc: (
      <div>
        Utilize linking between files for the ability to organize all of your
        code. Don&#x27;t put all your code in the same file - trust me{" "}
        <i>it&#x27;s not fun...</i>
      </div>
    ),
    vid_link: "428258888",
  },
  {
    _id: 8,
    title: "Creating the Top Navigation Bar",
    subtitle: "Styling up your nav-bar so visitors can see where to go.",
    time: "12:25",
    desc: "",
    vid_link: "428258902",
  },
  {
    _id: 9,
    title: "Adding a HERO to Your Site",
    subtitle: "All good sites need a hero.",
    time: "11:27",
    desc: "",
    vid_link: "428258914",
  },
  {
    _id: 10,
    title: "Unlocking Every Font You Could Ever Want",
    subtitle: "Not all fonts are created equal.",
    time: "6:15",
    desc: "",
    vid_link: "428258927",
  },
  {
    _id: 11,
    title: "The Finishing Touches",
    subtitle: "Polish off your new beautiful website",
    time: "17:30",
    desc: (
      <div>
        You can checkout the source-code for this entire project here:{" "}
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://github.com/jordankilburn/simple-portfolio-site/"
        >
          https://github.com/jordankilburn/simple-portfolio-site
        </a>
      </div>
    ),
    vid_link: "428258774",
  },
  {
    _id: 11.1,
    title: "Module 3: Going Online",
    desc: "",
  },
  {
    _id: 12,
    title: "Accessing All the Code You Need For Any Project",
    subtitle: "As well as saving your code at every step of the way.",
    time: "13:41",
    desc: (
      <div>
        You can download git here:{" "}
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://git-scm.com/downloads/"
        >
          https://git-scm.com/downloads
        </a>
        <br />
        <br />
        You can checkout the source-code for this entire project here:{" "}
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://github.com/jordankilburn/simple-portfolio-site.git/"
        >
          https://github.com/jordankilburn/simple-portfolio-site.git
        </a>
        <br />
        <br />
        <b>Useful Commands for Command Line:</b>
        <br />
        <br />
        Clone entire repository from github into local folder:
        <br />
        <code>
          git clone https://github.com/jordankilburn/simple-portfolio-site.git
        </code>
        <br />
        <br />
        Change current directory (cd followed by directory you want)
        <br />
        <code>cd simple-portfolio-site</code>
        <br />
        <br />
        Go up in the directory tree
        <br />
        <code>cd ..</code>
        <br />
      </div>
    ),
    vid_link: "428605251",
  },
  {
    _id: 13,
    title: "Putting Your Site Online - For Free",
    subtitle: "This is the fastest ways to get your site online.",
    time: "6:12",
    desc: (
      <div>
        Easily host your site for free using{" "}
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://netlify.com/"
        >
          Netlify
        </a>
        <p>
          Be sure to enable &#x27;Continuous Deployment&#x27; so everytime you
          push a change to github, it will automatically update your live
          website!
        </p>
      </div>
    ),
    vid_link: "428605239",
  },
]
